export default __webpack_public_path__ + "static/media/favicon.82c02091.ico";